export default __webpack_public_path__ + "static/media/filter.56e0598d.svg";